__turbopack_context__.v({
  "document": "DocumentList-module-scss-module__daOTCq__document",
  "fade-in": "DocumentList-module-scss-module__daOTCq__fade-in",
  "list": "DocumentList-module-scss-module__daOTCq__list",
  "no-transform": "DocumentList-module-scss-module__daOTCq__no-transform",
  "rotate": "DocumentList-module-scss-module__daOTCq__rotate",
  "title": "DocumentList-module-scss-module__daOTCq__title",
});
